module.exports = __webpack_public_path__ + "img/insta-5.bcc14665.jpg";